//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import promotion from "apis/promotion/promotion";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";
import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

const typeArr = [
  {
    label: "Multi Tier",
    value: "MULTI TIER",
  },
];

const frequencyArr = [
  {
    label: "Monthly",
    value: "MONTHLY",
  },
];

export default function View(props) {
  const { state, dispatch } = useContext(Context);

  const { updateRange } = promotion();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  const {t , i18n}= useTranslation();
  const [states, setstates] = useState({
    minimumAmount: "",
    maximumAmount: "",
    multiplier: "",
    sequence: "",
    isActive: true,
    data: {},
    edittedData: {},
    isEdit: false,
  });

  const {
    minimumAmount,
    maximumAmount,
    multiplier,
    sequence,
    isActive,
    data,
    edittedData,
    isEdit,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Promotion Management", "Range", "View"],
    });
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      minimumAmount: dataObj?.minimum_amount,
      maximumAmount: dataObj?.maximum_amount,
      multiplier: dataObj?.multiplier,
      sequence: dataObj?.sequence,
      isActive: dataObj?.is_active,
    });
  };

  const blockInvalidChar = (e) =>{
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
  }
  // update api func
  const handleUpdate = async () => {
    try {
      if (Object.keys(edittedData).length === 0) {
        toast.error("Please alter atleast one field.", {
          toastId: "update-error",
        });
        return;
      }
      if (
        parseInt(edittedData?.minimumAmount) >
        parseInt(edittedData?.maximumAmount)
      ) {
        toast.error("Minimum amount should be lesser than maximum amount", {
          toastId: "required-fields-error-0",
        });
        setStates({ loading: false });
        return;
      } else if (parseInt(edittedData?.minimumAmount) > maximumAmount) {
        toast.error("Minimum amount should be lesser than maximum amount", {
          toastId: "required-fields-error-0",
        });
        setStates({ loading: false });
        return;
      } else if (minimumAmount > parseInt(edittedData?.maximumAmount)) {
        toast.error("Maximum amount should be greater than minimum amount", {
          toastId: "required-fields-error-0",
        });
        setStates({ loading: false });
        return;
      }
      let failed = false;
      Object.keys(edittedData).map((o) => {
        if (!edittedData[o] && typeof edittedData[o] != "boolean") {
          failed = true;
        }
      });
      if (failed) {
        toast.error("Cannot update empty field.", {
          toastId: "update-error-2",
        });
        return;
      }

      let values;
      values = {
        ...edittedData,
        id: data?.id,
      };

      if (edittedData?.minimumAmount) {
        values = {
          ...values,
          minimumAmount: parseInt(edittedData?.minimumAmount),
        };
      }

      if (edittedData?.maximumAmount) {
        values = {
          ...values,
          maximumAmount: parseInt(edittedData?.maximumAmount),
        };
      }

      if (edittedData?.multiplier) {
        values = {
          ...values,
          multiplier: parseInt(edittedData?.multiplier),
        };
      }

      if (edittedData?.sequence) {
        values = {
          ...values,
          sequence: parseInt(edittedData?.sequence),
        };
      }

      let res = await updateRange(values);
      if (res?.data === 1) {
        toast.success("Updated", { toastId: "range-updated" });
        history.goBack();
      }
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18 }}>
            <strong>{t('View')}</strong>
          </span>
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                setStates({ isEdit: true });
              }}
            >
             {t('Edit')}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Minimum Amount')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  type={"number"}
              onWheel={(e) => e.target.blur()}
                  onKeyDown={blockInvalidChar}
                  // className={classes.cssTextField}
                  required
                  className={classes.editInput}
                  value={minimumAmount}
                  onChange={(e) => {
                    setStates({
                      minimumAmount: e.target.value,
                      edittedData: {
                        ...edittedData,
                        minimumAmount: e.target.value,
                      },
                    });
                  }}
                />
              ) : (
                <span className={classes.label}> {minimumAmount}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Maximum Amount')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  type={"number"}
              onWheel={(e) => e.target.blur()}
                  onKeyDown={blockInvalidChar}
                  // className={classes.cssTextField}
                  required
                  className={classes.editInput}
                  value={maximumAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if ((value === "" || (value > 0 && value.length <= 15))) {
                      setStates({
                     
                        maximumAmount: value,
  
                        edittedData: {
                          ...edittedData,
                          maximumAmount: value,
                        },
                      });

                      // setStates({ maximumAmount: value});
                    }
                  }}
                  error={maximumAmount.length === 15} // Show error when character limit is reached
                  helperText={maximumAmount.length === 15 ? "MaximumAmount cannot exceed" : ""}
                    
                 
                />
              ) : (
                <span className={classes.label}> {maximumAmount}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t('Additional Multiplier')} :{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  type={"number"}
              onWheel={(e) => e.target.blur()}
                  onKeyDown={blockInvalidChar}
                  // className={classes.cssTextField}
                  required
                  className={classes.editInput}
                  value={multiplier}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === ""||value > 0 ) {
                    setStates({
                      multiplier: value,
                      edittedData: {
                        ...edittedData,
                        multiplier: value,
                      },
                    });
                  }
                  }}
                />
              ) : (
                <span className={classes.label}> {multiplier}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Sequence')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  type={"number"}
              onWheel={(e) => e.target.blur()}
                  onKeyDown={blockInvalidChar}
                  // className={classes.cssTextField}
                  required
                  className={classes.editInput}
                  value={sequence}
                  onChange={(e) => {
                    setStates({
                      sequence: e.target.value,
                      edittedData: {
                        ...edittedData,
                        sequence: e.target.value,
                      },
                    });
                  }}
                />
              ) : (
                <span className={classes.label}> {sequence}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Is Active')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isActive}
                  onChange={(e) => {
                    setStates({
                      isActive: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isActive: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {isActive.toString()}</span>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {isEdit && (
            <Fragment>
              <Button
                className={classes.cancelBtn}
                onClick={() => {
                  setDataObj(data);
                  setStates({ isEdit: false, edittedData: {} });
                }}
              >
                {t('Cancel')}
              </Button>
              &nbsp; &nbsp; &nbsp;
              <Button
                className={classes.submitBtn}
                onClick={() => {
                  handleUpdate();
                }}
              >
                {t('Update')}
              </Button>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
